import { graphe1 } from "../composants/graphes/Graphes1";
import { graphe2 } from "../composants/graphes/Graphes2";
import { calculerMailles } from "../librairie/calculMailles";
import { SET_JETON,CALCULER_GRAPHE1, SET_AFFICHER_FENETRE_EXPORT, SET_ALERTE, SET_CHECKTHEME, SET_AFFICHER_LEGENDE, SET_AFFICHER_LISTE_COUCHES, CALCULER, SET_LISTE_DES_COUCHES, SET_CERCLE_PROPORTIONNEL, SET_FOND_DE_CARTE, SET_LISTE_THEMATIQUES, SET_TERRITOIRE, SET_THEME1, SET_THEME2, SET_THEME3, SET_LISTE_CERCLES_PROPORTIONNEL, CALCULER_GRAPHE2 } from "./actionTypes";

export const setJeton = (jeton) => ({
  type: SET_JETON,
  payload: {
    jeton
  }
});


export const setAlerte = (alertetexte, alertetype) => ({
  type: SET_ALERTE,
  payload: {
    alertetexte, alertetype
  }
});

export const setAfficherFenetreExport = (afficherfenetreexport) => ({
  type: SET_AFFICHER_FENETRE_EXPORT,
  payload: {
    afficherfenetreexport
  }
});

export const setCheckTheme = check => ({
  type: SET_CHECKTHEME,
  payload: check
});

export const calculer = (state) => (dispatch) => {
  graphe1(state.theme1, state.theme2, state.theme3, state.terriroire)
  .then(options => {
    dispatch({
      type: CALCULER_GRAPHE1,
      payload: {
        options
      }
    })

  })

  graphe2(state.theme1, state.theme2, state.theme3, state.terriroire)
  .then(options => {
    dispatch({
      type: CALCULER_GRAPHE2,
      payload: {
        options
      }
    })

  })

  calculerMailles(state)
    .then(mailles => {
      dispatch({
        type: CALCULER,
        payload: {
          maille: mailles
        }
      })
    })
}



export const setAfficherLegende = afficher => ({
  type: SET_AFFICHER_LEGENDE,
  payload: afficher
});

export const setAfficherListecouches = afficher => ({
  type: SET_AFFICHER_LISTE_COUCHES,
  payload: afficher
});


export const setListeThematiques = listethematiques => ({
  type: SET_LISTE_THEMATIQUES,
  payload: {
    listethematiques,
  }
});

export const setListeCerclesProportionnel = liste => ({
  type: SET_LISTE_CERCLES_PROPORTIONNEL,
  payload: {
    liste,
  }
});

export const setCercleProportionnel = cercleproportionnel => ({
  type: SET_CERCLE_PROPORTIONNEL,
  payload: {
    cercleproportionnel,
  }
});

export const setListeCouches = liste => ({
  type: SET_LISTE_DES_COUCHES,
  payload: {
    liste,
  }
});


export const setFondDeCarte = fonddecarte => ({
  type: SET_FOND_DE_CARTE,
  payload: {
    fonddecarte,
  }
});

export const setTerritoire = territoire => ({
  type: SET_TERRITOIRE,
  payload: {
    territoire,
  }
});

export const setTheme1 = theme => ({
  type: SET_THEME1,
  payload: {
    theme,
  }
});

export const setTheme2 = theme => ({
  type: SET_THEME2,
  payload: {
    theme,
  }
});

export const setTheme3 = theme => ({
  type: SET_THEME3,
  payload: {
    theme,
  }
});

export const calculGraphe1 = (state) => (dispatch) => {
  console.log(2)
  graphe1(state.theme1, state.theme2, state.theme3, state.terriroire)
    .then(options => {
      console.log(options)
      dispatch({
        type: CALCULER_GRAPHE1,
        payload: {
          options
        }
      })

    })


}
